import { AssessmentOutlined, VerifiedUserOutlined } from '@mui/icons-material';
import { Divider, List, ListItemIcon, ListItemText } from '@mui/material';
import { Restricted } from '@procureai/permissions-ui';
import { NavDrawerProps, NavSubListItem } from '@procureai/ui-mui';
import { Trans } from 'react-i18next';
import { Link, useMatch } from 'react-router-dom';

import { AstroSmartLinkDomain } from '@/generated/gql/graphql';
import { NavId, FeatureFlag } from '~/common/types';
import { NavDrawerSimple } from '~/components/NavDrawerSimple/NavDrawerSimple';
import { SmartLinksEditDialog } from '~/components/SmartLinksEditDialog/SmartLinksEditDialog';
import { SmartLinksNavList } from '~/components/SmartLinksNavList/SmartLinksNavList';
import { RouteId } from '~/routes/RouteId';

export const RiskSustainabilityDrawer = (props: NavDrawerProps) => {
  return (
    <NavDrawerSimple navId={NavId.riskSustainability} {...props}>
      <List disablePadding sx={{ marginBottom: 4 }}>
        <NavSubListItem
          component={Link}
          to={RouteId.riskSustainability}
          selected={!!useMatch({ path: RouteId.riskSustainability, end: true })}
        >
          <ListItemIcon>
            <VerifiedUserOutlined />
          </ListItemIcon>
          <ListItemText primary={<Trans i18nKey={`Nav.${NavId.riskSustainabilityOverview}`} />} />
        </NavSubListItem>
      </List>
      <Divider />
      <Restricted needs={{ feature: FeatureFlag.SMART_LINKS }}>
        <SmartLinksNavList
          domain={AstroSmartLinkDomain.RISK}
          Icon={AssessmentOutlined}
          label={<Trans i18nKey="Nav.riskReportsTitle" />}
        >
          <SmartLinksEditDialog
            domain={AstroSmartLinkDomain.RISK}
            label="riskManageReports"
            dialogTitle="riskManageReports"
          />
        </SmartLinksNavList>
      </Restricted>
    </NavDrawerSimple>
  );
};
